import { NavLink } from "react-router-dom";
import { urlparams } from "../../config/bootstrap";
import { onClickNavLinkMantra } from "../../utils/helper";

const HomeIcon = (props) => {
  let urlpath = window.location.pathname;
  return (
    <>
      <NavLink
        to={"/" + urlparams}>
        <img src="/assets/img/home.png" onClick={() => onClickNavLinkMantra("", { name: "home" })} className="img-fluid home_img" alt="" />
      </NavLink>
      {/* <NavLink
        to={"/" + urlparams}
        onClick={() => onClickNavLinkMantra("", { name: "home" })}
      > */}

      <img
        onClick={() => {
          if (props.goToFormBack) {
            props.backToForm()
          } else {
            onClickNavLinkMantra(urlpath, { name: "Back" });
            window.history.back();
          }
        }}
        src="/assets/img/back.png" className="img-fluid back_img" alt="" />
      {/* </NavLink> */}
    </>
    // <img
    //   src="/assets/img/home.png"
    //   onClick={() => {
    //     onClickNavLinkMantra(urlpath, { name: "Back" });
    //     window.history.back();
    //   }}
    //   className="img-fluid home_img"
    //   alt=""
    // />
  );
};

export default HomeIcon;
